module.exports = __webpack_public_path__ + "static/img/Video.b89c4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/browse/Video.jpg
// module id = 2235
// module chunks = 0